export default "__VITE_ASSET__fb734a19__"